export default "__VITE_ASSET__t5tEL5_7__"